const baseUrl = process.env.REACT_APP_BACKEND_HOST;

export default baseUrl;